import { GET_ARTICLE } from "./types";
import axios from "axios";

//get single article
export const getArticle = id => async dispatch => {
  try {
    let res = await axios.get(`https://tablesageapi.com/api/articles/${id}`);

    dispatch({
      type: GET_ARTICLE,
      payload: res.data.data,
    });
  } catch (err) {
    // LogRocket.log(err.message);
  }
};
